// ------------------------------------
// props 輸入需求 :
// props.content : object : { data: array }            ( 呈現內容 )
// props.callBack : function()                         ( 核取方塊確認時呼叫的函數 )
// ------------------------------------

import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './_PopConfirm.scss';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { ADD_RESPONSE } from '../../stores/reducer_add';
import ApiGo from '../../actions/ApiGo';
import Mos from '../../actions/Mos';
import { deleteResident, discharged } from '../residents/ResidentRow/ResidentRow';
import Account from '../../actions/Account';

const PopConfirm =(props)=>{
    const mos = Mos()
    const dispatch = useDispatch()
    const [checkedResidents, setCheckedResidents] = useState({}); //type="checkbox 選取
    const [selectedOption, setSelectedOption] = useState(null); //type="radio 選取
    const [btnIsLoading, setBtnIsLoading] = useState(false); //針對新增受護者的確認判別
    const { title,content,parameter, status, callBack, hide, setUpdateRedux , resident_data } = props;
    const _acc = new Account();
    const {t} = useTranslation()

    const handleConfirm = () => {
        const isExcludedStatus = ["addResident", "addResidentError", "same_Resident","addResidentError_dbLimit"].includes(status);
        if (!isExcludedStatus) {
            callBack(...parameter);
        }
        hide();
    };

    //type="radio 選取
    const handleOptionChange = (event) => {
        setSelectedOption(Number(event.target.value));
    };
    //type="checkbox 選取
    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        const [id, mac] = value.split('|');
        setCheckedResidents(prev => ({
            ...prev,
            [id]: { checked, mac }
        }));
    };

    //重新入院按鈕請求api
    const debouncedChangehospitalization = _.debounce(async()=>{
        if(!selectedOption || btnIsLoading) return
        setBtnIsLoading(true);
        try {
            await ApiGo.postBackToHospital(resident_data.accountInfo,selectedOption)
            dispatch(ADD_RESPONSE({ status: 200, statusText: "success", type: "change_resident" }));
            setUpdateRedux(true);
        } catch (err) {
            dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: "create_resident" }));
        } finally {
            setBtnIsLoading(false);
        }
    }, 500, { leading: false, trailing: true })
    //出院按鈕請求api
    const debouncedLeavehospital = _.debounce(()=>{
        const selectedResidents = Object.entries(checkedResidents)
            .filter(([_, value]) => value.checked)
            .map(([id, { mac }]) => ({
                id,
                mac: mac === "null" ? null : mac
        }));

        selectedResidents.forEach(async(resident)=>{
            await discharged(resident.mac, resident.id, dispatch, mos);
        })
        hide();
    }, 500, { leading: false, trailing: true })
    //刪除按鈕請求api
    const debouncedDelete = _.debounce(()=>{
        const selectedResidents = Object.entries(checkedResidents)
            .filter(([_, value]) => value.checked)
            .map(([id, { mac }]) => ({
                id,
                mac: mac === "null" ? null : mac
        }));

        selectedResidents.forEach(async(resident)=>{
            await deleteResident(resident.mac, resident.id, dispatch, mos);
        })
        hide();
    }, 500, { leading: false, trailing: true })

    //當新增受護者碰到相同姓名及病歷碼，跳出警告
    if(status==="same_Resident"){
        const same_account= (_acc.email===parameter[0].user_email && parameter[0].leave_hospital===null)
        return(
        <div className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-back" onClick={hide}>
        <div className={`popLayout fx-d-c pad-30 l r ${status === "same_Resident" ? 'w-80' : ""}`} onClick={e=>e.stopPropagation()}>
            <div className='w-60 fx-d-r font-l innerFrame mt'>
                <div className='w-100 fx-fsc'>{title}</div>
            </div>
            {same_account ? (
                <>
                <div className={`w-100 innerFrame mt font-ml mar-15 b`}>
                    <p><span className='font-red'>*</span>{t('POP_UP.same_Resident')}<span className='font-red'>{t('POP_UP.hospitalization_list')}</span>，{t('POP_UP.confirm_again')} !!</p>
                </div>
                </>
            ):(<>
                <div className={`w-100 innerFrame mt font-ml mar-15 b`}>
                    <div className=''><span className='font-red'>*</span>{t('POP_UP.confirmed_Resident')}<span className='font-red'>{t('POP_UP.hospitalized_pad')}</span>，{t('POP_UP.notify')}<span className='font-red'>{t('POP_UP.select_discharge')}</span>，{t('POP_UP.adding_again')}!!</div>
                    <p><span className='font-red'>*</span>{t('POP_UP.resident_status')}<span className='font-red'>{t('POP_UP.discharged')}</span>，{t('POP_UP.select_click')}<span className='font-red'>{t('POP_UP.Re-admit')}</span>{t('POP_UP.button')} !!</p>
                </div>
            </>)}
            <div className="wrap-residents fx-d-c h-100 mar-30 b">
                {/* 各分項標頭 */}
                <div className="residents-row-head">
                    <div className='d-flex head'>
                        <div className="flex-grow-1 head-container"><div className="head pad-5 t b">{t('POP_UP.select')}</div></div>
                        <div className="flex-grow-1 head-container"><div className="head pad-5 t b">{t('POP_UP.Create_date')}</div></div>
                        <div className="flex-grow-1 head-container"><div className="head pad-5 t b">{t('GLOBAL.NAME')}</div></div>
                        <div className="flex-grow-1 head-container"><div className="head pad-5 t b">{t('RESIDENTS_SETTING.MEDICAL_RECORD_NUMBER')}</div></div>
                        <div className="flex-grow-1 head-container"><div className="head pad-5 t b">{t('GLOBAL.BIRTHDAY')}</div></div>
                        <div className="flex-grow-1"><div className="head pad-5 t b">{t('NAV_BAR.PADS')}</div></div>
                        <div className="flex-grow-1"><div className="head pad-5 t b">{t('GLOBAL.STATE')}</div></div>
                        <div className="flex-grow-1"><div className="head pad-5 t b">{t('NAV_BAR.USERS')}</div></div>
                    </div>
                </div>

                {/* 各分項內容 */}
                <div className='reset-height'>
                    {parameter.map((resident)=>(
                        <div key={resident.id} className='residents-row-body font-ml'>
                            <div className='d-flex'>
                                <div className='flex-grow-1 body-container'>
                                <input
                                    type="radio"
                                    name="option"
                                    value={resident.id}
                                    checked={selectedOption === resident.id}
                                    onChange={handleOptionChange}
                                    className="form-radio text-blue-600"
                                    disabled={resident.mac !== null || same_account}
                                />
                                </div>
                                <div className='flex-grow-1 body-container'>
                                    <div className='body_resident'>{resident.created_at}</div>
                                </div>
                                <div className='flex-grow-1 body-container'>
                                    <div className='body_resident'>{resident.last_name}</div>
                                </div>
                                <div className='flex-grow-1 body-container'>
                                    <div className='body_resident'>{resident.med_record_num===""?"X":resident.med_record_num}</div>
                                </div>
                                <div className='flex-grow-1 body-container'>
                                    <div className='body_resident'>{resident.birthday===null?"X":resident.birthday}</div>
                                </div>
                                <div className='flex-grow-1 body-container' style={{ borderRight: '1px solid #735B69' }}>
                                    <div className='body mar-0'>{resident.mac===null?"X":resident.mac}</div>
                                </div>
                                <div className='flex-grow-1 body-container' style={{ borderRight: '1px solid #735B69' }}>
                                    <div className='body mar-0'>{resident.leave_hospital===null? t('RESIDENTS.STAY_IN'):t('RESIDENTS.DISCHARGED')
                                    }</div>
                                </div>
                                <div className='flex-grow-1 body-container' style={{borderRight:"none"}}>
                                    <div className='body_resident'>{resident.user_last_name}{resident.user_first_name}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="wrap-sensor-btn w-100 innerFrame cfBtn font-m">
                <div className="h-100 r-s-container"></div>
                <div className="h-100 l-s-container">
                    <div className={`h-100 flied ${(same_account || (parameter[0].leave_hospital===null && parameter[0].mac!==null)) && "jc-fe"}`}>
                        {(same_account || (parameter[0].leave_hospital===null && parameter[0].mac!==null)) || <div className="fx-ccc btn_type confirmBtn w-50" onClick={debouncedChangehospitalization}>{t('GLOBAL.CHANGE_HOSPITALIZATION')}</div>}
                        <div className="fx-ccc w-50 btn_type confirmBtn" onClick={handleConfirm}>{t('GLOBAL.CANCEL')}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
        );
    }

    //當新增受護者碰到資料庫限制，跳出警告
    if(status==="addResidentError_dbLimit") return(
        <div className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-back" onClick={hide}>
        <div className={`popLayout fx-d-c pad-30 l r w-60`} onClick={e=>e.stopPropagation()}>
            <div className='w-60 fx-d-r font-l innerFrame mt'>
                <div className='w-100 fx-fsc'>{title}</div>
            </div>
            <div className={`w-100 innerFrame mt font-ml mar-15 b`}>
                <div className=''><span className='font-red'>*</span>{t('NAV_BAR.RESIDENTS')}<span className='font-red'>{t('POP_UP.Maximum_people')}</span>，{t('POP_UP.select_first')}<span className='font-red'>{t('POP_UP.Delete_hospitalized')}</span>，{t('POP_UP.try_again')}!!</div>
            </div>
            <div className="wrap-residents fx-d-c mar-30 b" style={{height:"200px"}}>
                {/* 各分項標頭 */}
                <div className="residents-row-head">
                    <div className='d-flex head'>
                        <div className="flex-grow-1 head-container"><div className="head pad-5 t b">{t('POP_UP.select')}({t('POP_UP.Multiple_select')})</div></div>
                        <div className="flex-grow-1 head-container"><div className="head pad-5 t b">{t('POP_UP.Create_date')}</div></div>
                        <div className="flex-grow-1 head-container"><div className="head pad-5 t b">{t('GLOBAL.BED_NO')}</div></div>
                        <div className="flex-grow-1 head-container"><div className="head pad-5 t b">{t('GLOBAL.NAME')}</div></div>
                        <div className="flex-grow-1 head-container"><div className="head pad-5 t b">{t('NAV_BAR.PADS')}</div></div>
                    </div>
                </div>

                {/* 各分項內容 */}
                <div className='reset-height'>
                    {parameter.map((resident)=>(
                        <div key={resident.id} className='residents-row-body font-ml pad-5 t b'>
                            <div className='d-flex'>
                                <div className='flex-grow-1 body-container'>
                                <input
                                    type="checkbox"
                                    name="resident"
                                    value={`${resident.id}|${resident.mac}`}
                                    checked={checkedResidents[resident.id]?.checked || false}
                                    onChange={handleCheckboxChange}
                                    className="form-radio text-blue-600"
                                />
                                </div>
                                <div className='flex-grow-1 body-container'>
                                    <div className='body_resident'>{resident.created_at}</div>
                                </div>
                                <div className='flex-grow-1 body-container'>
                                    <div className='body_resident'>{resident.first_name}</div>
                                </div>
                                <div className='flex-grow-1 body-container'>
                                    <div className='body_resident'>{resident.last_name}</div>
                                </div>
                                <div className='flex-grow-1 body-container' style={{borderRight:"none"}}>
                                    <div className='body_resident'>{resident.mac===null?"X":resident.mac}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="wrap-sensor-btn w-100 innerFrame cfBtn font-m">
                <div className="h-100 r-s-container"></div>
                <div className="h-100 l-s-container">
                    <div className={`h-100 flied`}>
                        <div className="fx-ccc btn_type confirmBtn w-50" onClick={debouncedLeavehospital}>{t('RESIDENTS.DISCHARGED')}</div>
                        <div className="fx-ccc btn_type confirmBtn w-50" onClick={debouncedDelete}>{t('RESIDENTS.DELETE')}</div>
                        <div className="fx-ccc w-50 btn_type confirmBtn" onClick={handleConfirm}>{t('GLOBAL.CANCEL')}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
    //碰到相同姓名、生日，跳出提示輸入病歷號
    if(status==="addResidentError") return(
        <div className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-back" onClick={hide}>
        <div className="popLayout fx-d-c pad-30 l r" onClick={e=>e.stopPropagation()}>
            <div className='w-60 fx-d-r font-l innerFrame mt'>
                <div className='w-100 fx-fsc'>{title}</div>
            </div>
            <div className="w-100 innerFrame mt font-ml">
                <div className=''>{t('POP_UP.Already_exists')}<span className='font-red'>{t('POP_UP.same_name')}</span>，{t('POP_UP.enter_again')}<span className='font-red'>{t('RESIDENTS_SETTING.MEDICAL_RECORD_NUMBER')}</span>，{t('POP_UP.click_add')}!!</div>
            </div>
            <div className="wrap-sensor-btn w-100 innerFrame cfBtn font-m">
                <div className="h-100 r-s-container"></div>
                <div className="h-100 l-s-container">
                    <div className="h-100 flied jc-fe" >
                        <div className="fx-ccc btn_type confirmBtn w-50" onClick={handleConfirm}>{t('GLOBAL.CONFIRM')}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
    //請檢查 病歷號 或 生日 ，兩者欄位必須擇一選填!!
    //請檢查 姓名 跟 床號 ，必填!!
    if(status==="addResident") return(
        <div className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-back" onClick={hide}>
        <div className="popLayout fx-d-c pad-30 l r" onClick={e=>e.stopPropagation()}>
            <div className='w-60 fx-d-r font-l innerFrame mt'>
                <div className='w-100 fx-fsc'>{title}</div>
            </div>
            <div className="w-100 innerFrame mt font-ml">
                <div className=''>{t('POP_UP.check')} <span className='font-red'>{t('GLOBAL.NAME')}</span>、<span className='font-red'>{t('GLOBAL.BED_NO')}</span>，{t('GLOBAL.REQUIRED')}!!</div>
                <div className=''>{t('POP_UP.check')} <span className='font-red'>{t('RESIDENTS_SETTING.MEDICAL_RECORD_NUMBER')}</span> {t('POP_UP.or')} <span className='font-red'>{t('GLOBAL.BIRTHDAY')}</span>，{t('POP_UP.two_fields_filled')}!!</div>
            </div>
            <div className="wrap-sensor-btn w-100 innerFrame cfBtn font-m">
                <div className="h-100 r-s-container"></div>
                <div className="h-100 l-s-container">
                    <div className="h-100 flied jc-fe">
                        <div className="fx-ccc btn_type confirmBtn w-50" onClick={handleConfirm}>{t('GLOBAL.CONFIRM')}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );

    return(
        <div className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-back" onClick={hide}>
        <div className="popLayout fx-d-c pad-30 l r" onClick={e=>e.stopPropagation()}>
            <div className='w-60 fx-d-r font-l innerFrame mt'>
                <div className='w-100 fx-fsc'>{title}</div>
            </div>
            <div className={`w-100 innerFrame mt ${status === "addResident" || status === "addResidentError" ? 'font-ml' : "font-m"}`}>
                <div className=''>{content}</div>
            </div>
            <div className="wrap-sensor-btn w-100 innerFrame cfBtn font-m">
                <div className="h-100 r-s-container"></div>
                <div className="h-100 l-s-container">
                    <div className={`h-100 flied ${ status === "addResident" || status === "addResidentError" ? 'jc-fe' : ""}`}>
                        <div className="fx-ccc btn_type confirmBtn w-50" onClick={handleConfirm}>{t('GLOBAL.CONFIRM')}</div>
                        { status === "addResident" || status === "addResidentError" || <div className="fx-ccc w-50 btn_type confirmBtn" onClick={hide}>{t('GLOBAL.CANCEL')}</div>}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );

}
export default PopConfirm;

export const PopConfirm_ReAssignPad =(props)=>{
    const title = props.title
    const content = props.content
    const parameter = props.parameter
    const {t} = useTranslation()

    return(
        <div className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-back" onClick={props.hide}>
        <div className="popLayout fx-d-c pad-30 l r" onClick={e=>e.stopPropagation()}>
            <div className='w-60 fx-d-r font-l innerFrame mt'>
                <div className='w-100 fx-fsc'>{title}</div>
            </div>
            <div className='w-100 innerFrame font-m mt'>
                <div className=''>{content}</div>
            </div>
            <div className="wrap-sensor-btn w-100 innerFrame cfBtn font-m">
                {/* <div className="h-100"></div> */}
                <div className="h-100 w-50">
                    <div className="h-100 flied">
                        <div className='w-50'></div>
                        <div className="fx-ccc w-50 btn_type confirmBtn" style={{textAlign:'center'}} onClick={()=>{
                            props.callBack2(...parameter)
                            props.hide()
                            }}>{t('POP_UP.ASSIGN_PAD')}</div>
                    </div>
                </div>
                <div className="h-100 w-50">
                    <div className="h-100 flied">
                        <div className="fx-ccc w-50 btn_type confirmBtn" style={{textAlign:'center'}} onClick={()=>{
                            props.callBack1(...parameter)
                            props.hide()
                            }}>{t('POP_UP.DIRECT_DISCHARGE')}</div>
                        <div className="fx-ccc w-50 btn_type confirmBtn" onClick={props.hide}>{t('GLOBAL.CANCEL')}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );

}
